<script lang="ts">
  import { onMount } from 'svelte';
  import { push, link } from 'svelte-spa-router';
  import { location } from '../../framework/js/spaLocation';
  import BriefView from '../brief/BriefView.svelte';

  /** Read brief ID from the address bar (works regardless of router timing). */
  function getBriefIdFromPath(): string | undefined {
    if (typeof window === 'undefined') return undefined;
    const path = (window.location.hash || '').replace(/^#\/?/, '/').split('?')[0];
    if (!path.startsWith('/admin/briefs/') || path === '/admin/briefs') return undefined;
    const segment = path.slice('/admin/briefs/'.length).split('/')[0]?.trim();
    return segment && segment.length > 0 ? segment : undefined;
  }

  /** Read from= param to show correct back link (briefs vs requests). */
  function getFromParam(): 'briefs' | 'requests' {
    if (typeof window === 'undefined') return 'briefs';
    const hash = window.location.hash || '';
    const queryPart = hash.includes('?') ? hash.split('?')[1] : '';
    const params = new URLSearchParams(queryPart);
    const from = params.get('from');
    return from === 'requests' ? 'requests' : 'briefs';
  }

  $: briefId = getBriefIdFromPath() || ($location || '').replace(/^#\/?/, '/').replace(/^\/admin\/briefs\/?/, '').split('/')[0]?.trim() || '';
  $: fromContext = ($location && getFromParam()) || 'briefs';

  onMount(() => {
    if (!getBriefIdFromPath()) {
      push('/admin/briefs');
    }
  });
</script>

<div class="admin-brief-detail">
  <a href={fromContext === 'requests' ? '/admin/proposal-requests' : '/admin/briefs'} class="back-link" use:link>
    <i class="arrow left icon"></i>
    {fromContext === 'requests' ? 'Back to requests' : 'Back to briefs'}
  </a>
  {#if briefId}
    <BriefView briefId={briefId} adminMode={true} />
  {/if}
</div>

<style>
  .admin-brief-detail {
    padding: 0;
  }

  .back-link {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 1rem;
    color: var(--primary);
    text-decoration: none;
    font-weight: 500;
  }

  .back-link:hover {
    color: var(--darkprimary);
    text-decoration: underline;
  }
</style>
